









































































































import {
Vue,
photosUrlEnum,
mixpanelEvents
} from "../../constants/constants";
import { staticContent } from "../../localisation/detect-lang";

import moment from "moment";
import {
updatePhotosURL, pushMixpanelEvent} from "../../helpers";

export default Vue.extend({
name: "menu-item",
props: {
 item: {},
 itemIndex: 0,
 category: {},
 menuAvailable: "",
 menuAvailableFrom: null,
 menuAvailableTo: null,
 menuAvailableForOnlineOrering: null,
},
data() {
 return {
   staticContent,
   photosUrlEnum,
   pushMixpanelEvent,
   updatePhotosURL,
   mixpanelEvents,

 };
},
computed: {
 likedItems(){
   return this.$parent.likedItems
 },
 profile() {
     return this.$store.getters.getProfileData;
   },
 hideMenuItemTooltip(){
   return this.$root.hideMenuItemTooltip;
 },
 restaurantInfo(){
   return this.$root.restaurantPage.restHeaderObj;
 },
 items(){
   return this.$parent.flatItems;
 },
 notAvailable() {
   if (
     !this.item.availability.availableInBranch ||
     !this.menuAvailable ||
     (this.branchEnabled && !this.item.availability.availableForDelivery)
   ) {
     return "not-available";
   }
   return "";
 },
 sortedPrices() {
   return this.item.sizes
     .map((size) => size.price)
     .sort((a, b) => a - b);
 },
 sortedOldPrices() {
   return this.item.sizes
     .map((size) => size.oldPrice || size.price)
     .sort((a, b) => a - b);
 },
 
 userAreaObj() {
   return this.$root.userArea;
 },
 branchEnabled() {
   return this.$root.restaurantPage.restHeaderObj.branchOrderingEnabled;
 },
 doesDeliverToUser(){
   return this.$root.deliveryStatus.isDeliver || this.$root.isGroupOrderPage;
 }
},
mounted() {},
methods: {
 availableOnTime() {
   return this.category.availability.timeAvailability.availabilityNow;
 },
 isItemLiked(itemUUID){
  return this.$parent.isItemLiked(itemUUID)
 },
 itemLikeHandler(liked: boolean, itemUUID: string, initialLikes: number) {
   return this.$parent.itemLikeHandler(liked, itemUUID, initialLikes)
 },
 getItemLikes(itemUUID){
  return this.$parent.getItemLikes(itemUUID)
 },

 toFixedPriceFloored(price) {
   return this.$root.toFixedPriceFloored(price);
 },
 addLikes(itemUUID, method) {
  return this.$parent.addLikes(itemUUID, method)
 },

 formatTime(timeParam) {
   return timeParam
     ? moment(timeParam,"hh:mm:ss").add(moment().utcOffset(),'m').format('HH:mm')
     : "";
 },
 isWithinTimeFrame(openingTime: string, closingTime: string) {
   let oldFormat = "HH:mm:ss";
   let newFormat = "HHmmss";
   openingTime = moment(openingTime, oldFormat).format(newFormat);
   closingTime = moment(closingTime, oldFormat).format(newFormat);
   let timeNow = moment()
   .format(newFormat); // getting current time from user's local device
   // but, should API return the opening/closing time with timezone to solve it forever
   return (
     openingTime == closingTime || // open 24 hours
     (openingTime < closingTime &&
       openingTime < timeNow &&
       closingTime > timeNow) || // both open and close in the same day
     (openingTime > closingTime && // open <  midnight close after midnight 10 pm to 2 am
       ((openingTime < timeNow && closingTime < timeNow) || // <  midnight part 11 pm
         (openingTime > timeNow && closingTime > timeNow))) // after midnight part 1 am
   );
 },
 itemModalClick(catUUID, uuid, name, menuAvailableOnTime = true, availableOnTime = true, menuFromTime = '', menuToTime = '', fromTime = '', toTime = '', menuAvailableForOnlineOrering=true) {
   this.$parent.itemModalClick(catUUID, uuid, name, menuAvailableOnTime, availableOnTime, menuFromTime, menuToTime, fromTime, toTime, menuAvailableForOnlineOrering)
   },
 modalToggler(modalId, method) {
   this.$root.modalToggler(modalId, method);
 },
},
});
